/**
 * Single source of truth for every raw color value in the app.
 * To re-theme the application, change values here only. Components must
 * never hardcode hex/rgba values; they consume tokens via theme.palette.*
 */
export const colors = {
  primary: {
    main: "#4664FB",
    dark: "#263EB5",
    light: "#C4CFFD",
    contrastText: "#E7F2FF"
  },
  success: {
    main: "#4CC2C2",
    dark: "#009494",
    light: "#CDF9D9"
  },
  warning: {
    main: "#FDBB64",
    dark: "#EF6C00",
    light: "#FFDBBE"
  },
  error: {
    main: "#FE5144",
    dark: "#E8111C",
    light: "#FFE0E0"
  },
  grey: {
    100: "#FFFFFF",
    200: "#FAFAFB",
    300: "#EFF1F6",
    400: "#E4E7ED",
    500: "#CBCFD8",
    600: "#919AAA",
    700: "#6E798F",
    750: "#212121",
    800: "#102B61",
    900: "#0B0B0B"
  },
  secondary: {
    main: "#F3F8FF",
    dark: "#850A10",
    light: "#212121",
    contrastText: "#454545"
  },
  badge: {
    core: { text: "#184641", background: "#B1DFDA", border: "#76C6BF" },
    kvi: { text: "#42008E", background: "#DCC8F3", border: "#D0ACFB" },
    discontinued: {
      text: "#850A10",
      background: "#FFE0E0",
      border: "#EFA8AF"
    }
  },
  chart: {
    departmentName: "#4564FA",
    label: "#0A0A0A",
    labelRed: "#850A10",
    lastYearPrice: "#C4CEFD",
    barGraphRed: "#FD5144",
    axis: "#D8D8D8",
    positive: "#008326",
    negative: "#FD5144",
    neutral: "#919AAA"
  },
  utility: {
    white: "#FFFFFF",
    black: "#000000",
    grey: "#808080",
    weatheredStone: "#C5C5C5",
    homeopathicLilac: "#E1E3E9",
    lightYellow: "#FFFFE0",
    paperWhite: "#EFF1F6",
    nyanza: "#E6FFD9",
    poblano: "#008326",
    cascara: "#F44336",
    mantis: "#66BB6A",
    mango: "#FFA726",
    overlay: "#00000029",
    shadow: "#00000080",
    border: "#E4E7ED",
    textPrimary: "#000000DE",
    laguna: "#3FA9C4"
  },
  extended: {
    surfaceBlue: "#F5F9FF",
    surfaceBlueAlt: "#E4F1FF",
    surfaceBlueDark: "#E3E8FB",
    accentPurple: "#950095",
    accentPurpleLight: "#D37FEC",
    accentPurpleDark: "#42008E",
    tanYellow: "#FCEDB6",
    olive: "#85720A",
    salmon: "#E57373",
    link: "#091777"
  },
  department: {
    Grocery: "#DEEDCD",
    Frozen: "#F0DA9F",
    Deli: "#F7EEAC",
    "Beer/Wine": "#FBD1B3",
    GM: "#CBF0FF",
    Meat: "#DDD5FF",
    Department1: "#F7DBFF",
    Department2: "#E8CFDF",
    Department3: "#FBC7C7"
  },
  highlight: {
    blue: { text: "#001483", background: "#B1BEFF" },
    green: { text: "#008326", background: "#E6FFD9" },
    red: { text: "#850A10", background: "#FFE0E0" },
    neutral: { text: "#212121", background: "#EFF1F6" }
  },
  global: {
    appBackground: "#EEEEEE",
    calendarMuted: "#CACDD4",
    viewPdfInputBackground: "#161719",
    viewPdfToolbarBackground: "#323639",
    viewPdfToolbarDivider: "#5c5f61",
    exportHighlightBorder: "#4966FB"
  }
};
